import React from 'react';
import styles from './NewUserForm.module.scss';
import UserForm from 'component/molecules/new-user/userForm/UserForm';
import { useFetch } from 'hooks/useFetch';
import { userEndpoints } from 'hooks/endpoints';
const NewUserForm = ({ id, formRef, AddUser, EditUser }) => {
  const {
    data: data,
    refetch: refetch,
    isFetching: isFetching,
  } = useFetch(['userDetailsById', id], userEndpoints?.getUserById(id), {
    enabled: id != null,
  });
  return (
    <div className={styles.cont}>
      {/* <UserImage userImage={data?.data?.userImage?.userImage} /> */}
      <UserForm
        id={id}
        data={data}
        isFetching={isFetching}
        formRef={formRef}
        AddUser={AddUser}
        EditUser={EditUser}
      />
    </div>
  );
};

export default NewUserForm;
